import { Component, type ReactNode } from 'react';
import { ErrorPage } from '@/shared/components/error-page';

interface Props {
  children?: ReactNode;
}

interface State {
  error: unknown;
  failed: boolean;
}

/**
 * Last-resort boundary around everything below the theme: shows the plain error page. Route
 * errors are handled earlier by the root route's error component. The back-office sends no
 * client error reports (the customer reporting route belongs to the customer API surface).
 */
export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { error: undefined, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <ErrorPage
          error={this.state.error}
          onRetry={() => {
            this.setState({ error: undefined, failed: false });
          }}
        />
      );
    }
    return this.props.children;
  }
}
